import {useState, useContext} from 'react';
import {UserContext, UpdateUserContext} from "../../App"
import {Link} from "react-router-dom"
import './Header.css';
import {Logo_MAQ} from "./Logo_MAQ"

export function Header ({handleLogout}) {
	
	const {currentUser} = useContext(UserContext)
	const user = currentUser
  const updateUsercontext = useContext(UpdateUserContext)

	const [navbar, setNavbar] = useState({
		menu1:false,
		menu2:false, 
		recup_msg:[]
	})

	const menu0 = {
		'Collège': ['college/college.php', 'Partie Collège'], 
		'Lycée': ['lycee/lycee.php', 'Partie Lycée'], 
		'Livre': ['livre/livre.php', 'Informations sur l\'ouvrage'], 
		'Divers': ['atelier.php', 'Ateliers, colloque...'],
		'Automaths': ['automaths', 'Automatismes et questions flash en mathématiques'],
	}
	let menu = [
		{content:'Connexion', lien:'/compte', title:'Connexion'}, 
		{content:'Aide', lien:'/tuto', title:'TutAutomaths'}, 
	]
	
	const menu_user = [
		{content:'Mon espace', lien:'/compte', title:'Mon_espace'}, 
		{content:'Aide', lien:'/tuto', title:'TutAutomaths'}, 
		{content:'Deconnexion', lien:'/logout', title:'Deconnexion'}, 
	]
	const menu_admin = [
		{content:'Administration', lien:'https://maths-au-quotidien.fr/admin.php', title:'Administration'}, 
		{content:user.msgs?.length + ' Messages', lien:'https://maths-au-quotidien.fr/admin.php#message', title:'Messages'}, 
		//{content:'Connexions', lien:'https://maths-au-quotidien.fr/admin.php#connexion', title:'Connexions'}, 
		//{content:'Comptes', lien:'https://maths-au-quotidien.fr/liste_comptes.php', title:'Comptes'}, 
	].concat(menu_user)

	
	if(user.statut === 'user') {menu = menu_user}
	else if(user.statut === 'admin_314159') {menu = menu_admin}

	const handleClick = (e) => {
		if(e.target.title === 'menu1'){
			setNavbar({...navbar, menu1:!navbar.menu1, menu2:false})
		} 
		if(e.target.title === 'menu2') {
			setNavbar({...navbar, menu1:false, menu2:!navbar.menu2})
		}
		if(e.target.parentNode.title === 'menu1'||e.target.parentNode.parentNode.parentNode.title === 'menu2') {
			setNavbar({...navbar, menu1:false, menu2:false})
		}
		if(e.target.attributes.name?.nodeValue === 'suppr_msg') {
			setNavbar({...navbar, recup_msg:[]})
			user.msgs = []
		}
	}

	if(!user.profil){updateUsercontext()}

	//console.log(navbar.recup_msg)
	//console.log(user)
  return (
    <>
    	<ul title="menu1" className={'icone'+(navbar.menu1 ? ' active' : '')} onClick={handleClick}>
    			<a href="https://maths-au-quotidien.fr/index.php">
    		<li className="icone-0">
  				<div className="logo_livre">Les maths</div>
  				<br/>
  				<div className="logo_livre2">au quotidien</div>
    		</li>
    			</a>
    		{Object.keys(menu0).map((e, k) => 
    			<a key={k} href={'/'+menu0[e][0]} title={menu0[e][1]} >
    				<li className='icone' >{e}</li>
    			</a>
    		)}

    		{/*<Link to="/automaths" title="Automatismes et questions flash en mathématiques" className="btn">Automaths</Link>
				*/}
			
    		<li className="icone search">
					<input className="recherche" type="text" placeholder="Entrez votre recherche" name="recherche" title="Rechercher"/>
				</li>
    	</ul>

    	<Logo_MAQ />

    	<div title="menu2" className="supermenu" onClick={handleClick}>
    		<div className={'sousmenu' + (navbar.menu2 ? ' active':'')}>
    			<div align="center">{user.profil !== 'Professeur' ? user.prenom : ''} {user.nom}</div>
    			{<>
    				{
    					menu.map((e, k) => k < menu.length-3 ? 
    						<a key={k} href={e.lien} title={e.title} >
			    				<li className={e.title} >&nbsp;{e.content}</li>
			    			</a> : 
		    				<li key={k} className={e.title} >
		    					<Link to={e.lien} title={e.title}>&nbsp;{e.content}</Link>
		    				</li>
		    				)
    				}
						{
							/*currentUser.nom && 
							<span style={{color:"maroon", cursor:"pointer"}} title="Deconnexion" onClick={handleLogout} >
		    				<li className="Deconnexion" >Déconnexion</li>
		    			</span>*/
			    	}
    				</>
    			}
    		</div>
    	</div>

    	{/*
    		user.statut === 'admin_314159' && user.msgs?.length ? 
    		<div className="msg_admin_contain">
				<h1>Vous avez {user.msgs?.length} nouveau message.</h1>
    		<div className="contain">
	    		{user.msgs?.map((e, k) =>
	    					    		<div key={k} className="msg_admin">
	    						    		<div name='suppr_msg' id={e.id} className="suppr_serie" onClick={handleClick}></div>
	    						    		<b>Objet</b> : {e.objet} <br/>
	    						    		<b>De</b> : {e.mail} <br/>
	    						    		<b>Le</b> : {e.ddm} <br/>
	    						    		<b>Message</b> :  {e.message} 
	    						    	</div>
	    			    			)
	    		}
    		</div>
    		</div>
	    	:''*/
	    }
    </>
  )
}